function JoyTycoonPlace(config,config_items) {
  myPixiElement.container.call(this);


  this.config = $.extend(true,{
        containerPos:[0,0],
        plate_count:0,
  },config);
  this.config_items= $.extend(true,{},config_items);
  this.x=this.config.containerPos[0];
  this.y=this.config.containerPos[1];
  this.plateSet={};
  
//  this.init();
}
JoyTycoonPlace.prototype = Object.create(myPixiElement.container.prototype);
JoyTycoonPlace.prototype = $.extend(JoyTycoonPlace.prototype, {
    init:function(){
        var i,obj,row,pos,size,qconf;
        for(i=1;i<=this.config.plate_count;i++){
            qconf=this.config_items[i];
            pos=copyArray(qconf.pos);
            size=qconf.size;
            size=[Math.round(size[0]/2),Math.round(size[1]/2)];
            obj=new myPixiElement.img({anchor:qconf.anchor,pos:pos,"img":qconf.img});
            row={obj:obj,busy:0,pos:[pos[0]+this.config.containerPos[0]+size[0],pos[1]+this.config.containerPos[1]+size[1]]};
            this.plateSet[i+""]=row;
            this.addChild(obj);
        }
    },
    findFree:function(){
        var res={res:0,pos:[0,0]};
        var key,bum;
        for(key in this.plateSet){
            bum=this.plateSet[key];
            if(bum.busy==0 ){
                res.res=intval(key);
                res.pos=copyArray(bum.pos);
                return res;
            }
        }
        return res;
    },
    setBusy:function(index){
        this.plateSet[index].busy=1;
    },
    setFree:function(index){
        this.plateSet[index].busy=0;
    },
});

